import axios from 'axios';
import { authToken } from './authentication.script';

export async function fetchDocumentPdf(companyId: string, path: string, id: string): Promise<string> {
  const url = `${process.env.REACT_APP_PORT_ADMIN}/${companyId}/${path}/${id}/pdf`

  const response = await axios.get(url, {
    headers: { Authorization: authToken() },
    responseType: 'blob',
  })

  const type = response.data?.type || response.headers?.['content-type'] || ''
  if (!type.includes('application/pdf')) {
    const text = await response.data.text?.().catch(() => '')
    throw new Error(text || 'PDF non disponible')
  }

  const blob = new Blob([response.data], { type: 'application/pdf' })
  return URL.createObjectURL(blob)
}
